import { callFunction } from "./functions-client";

// Per-field PII visibility settings (ADR-0018).

export type Visibility = "private" | "connections" | "public";

export interface PrivacySettings {
  name_visibility: Visibility;
  email_visibility: Visibility;
  phone_visibility: Visibility;
}

export interface PrivacyContact {
  email: string | null;
  real_name: string | null;
  phone: string | null;
}

export const VISIBILITY_LEVELS: Visibility[] = ["private", "connections", "public"];

export const getPrivacy = () =>
  callFunction<{ settings: PrivacySettings; contact: PrivacyContact }>("privacy/me", { method: "GET" });

export const updatePrivacy = (input: Partial<PrivacySettings> & { real_name?: string; phone?: string }) =>
  callFunction<{ settings: PrivacySettings; contact: PrivacyContact }>("privacy/update", { body: input });
